package com.example.mystybag.sharedmodels.project.responseModels

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class CheckUserExistsResponseModel(
    val isExistingUser: Boolean = false
): BaseResponseModel()
